import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, MenuItem } from '@mui/material';
import Grid from '@mui/system/Unstable_Grid';
import * as yup from 'yup';
import { useFormik } from 'formik';
const DialogContacto = ({ onClose, initial, contactos, ...props }) => {
    const formik = useFormik({
        initialValues: initial ?? {},
        validationSchema: yup.object({
            contactoId: yup.number().required('O campo é obrigatório')
        }),
        validateOnMount: false,
        onSubmit: async (values) => {
            if (onClose)
                onClose(values);
        }
    });
    return (<Dialog {...props}>
      <form>
        <DialogTitle>Selecionar contacto</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid lg={12} md={12} xs={12}>
              <TextField label='Contacto' name='contactoId' value={formik.values?.contactoId} onChange={formik.handleChange} onBlur={formik.handleBlur} fullWidth error={formik.touched.contactoId && Boolean(formik.errors.contactoId)} helperText={formik.touched.contactoId && formik.errors.contactoId} required select>
                <MenuItem value='' disabled>
                  Escolha uma opção da lista
                </MenuItem>
                {contactos.map(x => (<MenuItem value={x.id} key={x.id}>
                    {x.nome}
                  </MenuItem>))}
              </TextField>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button type='button' onClick={() => {
            if (onClose)
                onClose(undefined);
        }}>
            Cancelar
          </Button>
          <Button onClick={() => {
            formik.handleSubmit();
        }} disabled={!formik.isValid || !formik.dirty || formik.isSubmitting} variant='contained'>
            OK
          </Button>
        </DialogActions>
      </form>
    </Dialog>);
};
export default DialogContacto;
